import React from 'react';
import propTypes from './propTypes';

const AboutFuel = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M19.53 7.22L19.52 7.23C19.97 7.68 20.25 8.31 20.25 9V18.5C20.25 19.88 19.13 21 17.75 21C16.37 21 15.25 19.88 15.25 18.5V13.5H13.75V21H3.75V5C3.75 3.9 4.65 3 5.75 3H11.75C12.85 3 13.75 3.9 13.75 5V12H14.75C15.85 12 16.75 12.9 16.75 14V18.5C16.75 19.05 17.2 19.5 17.75 19.5C18.3 19.5 18.75 19.05 18.75 18.5V11.29C18.44 11.42 18.11 11.5 17.75 11.5C16.37 11.5 15.25 10.38 15.25 9C15.25 7.93 15.92 7.03 16.86 6.67L14.75 4.56L15.81 3.5L19.53 7.22ZM11.75 19V12H5.75V19H11.75ZM11.75 10H5.75V5H11.75V10ZM16.75 9C16.75 9.55 17.2 10 17.75 10C18.3 10 18.75 9.55 18.75 9C18.75 8.45 18.3 8 17.75 8C17.2 8 16.75 8.45 16.75 9Z" fill="currentColor" />
  </svg>
);

AboutFuel.propTypes = propTypes;

export default AboutFuel;
